import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::store
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions'
*/
export const store = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::store
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions'
*/
store.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return store.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::store
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions'
*/
store.post = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::update
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
export const update = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::update
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
update.url = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            expenditurePosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        expenditurePosition: typeof args.expenditurePosition === 'object'
        ? args.expenditurePosition.id
        : args.expenditurePosition,
    }

    return update.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{expenditurePosition}', parsedArgs.expenditurePosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::update
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
update.put = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::update
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
update.patch = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::destroy
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::destroy
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            expenditurePosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        expenditurePosition: typeof args.expenditurePosition === 'object'
        ? args.expenditurePosition.id
        : args.expenditurePosition,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{expenditurePosition}', parsedArgs.expenditurePosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ExpenditurePositionController::destroy
* @see app/Http/Controllers/Investors/ExpenditurePositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/expenditure-positions/{expenditurePosition}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, expenditurePosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const ExpenditurePositionController = { store, update, destroy }

export default ExpenditurePositionController